module.exports = __webpack_public_path__ + "media/images/allcareacademy-e0ce22e2c02168ed0765ccee49dc5b28.png";